export const path = "/specials";
